import { render, staticRenderFns } from "./layout_template.vue?vue&type=template&id=6f356d34&scoped=true&"
import script from "./layout_template.vue?vue&type=script&lang=js&"
export * from "./layout_template.vue?vue&type=script&lang=js&"
import style0 from "./layout_template.vue?vue&type=style&index=0&id=6f356d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f356d34",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6f356d34', component.options)
    } else {
      api.reload('6f356d34', component.options)
    }
    module.hot.accept("./layout_template.vue?vue&type=template&id=6f356d34&scoped=true&", function () {
      api.rerender('6f356d34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/monitor/_tool/layout_template.vue"
export default component.exports